export default class BackToSearch {
    constructor(w) {
        this.$window = w;
    }

    store() {
        sessionStorage.lastSearch = this.$window.location.pathname + this.$window.location.search;
    }

    rewrite(element) {
        let $el = $(element);

        if (sessionStorage.lastSearch === undefined) {
            return;
        }

        let attributeName = $el.data('link') ? 'data-link' : 'href';
        let attributeLink = sessionStorage.getItem('lastSearch');

        if (!this.isValidUrl(attributeLink)) {
            sessionStorage.lastSearch = '';
            return;
        }

        $el.attr(attributeName, this.escapeLink(attributeLink));
    }

    isValidUrl(link) {
        return (link.length > 0 && link.substr(0, 1) === '/');
    }

    escapeLink(link) {
        return link
            .replace(/\&/g, '&amp;')
            .replace(/\</g, '&lt;').replace(/\>/g, '&gt;')
            .replace(/\"/g, '&quot;').replace(/\'/g, '&#x27');
    }
}
